// extracted by mini-css-extract-plugin
module.exports = {"authContainer":"Authentication_authContainer__2iYp7"};